import * as types from '@/store/mutationTypes';

export default {
  [types.SET_CROSS_TENANT_SESSION](state, crossTenantSession) {
    state.crossTenantSession = crossTenantSession;
  },
  [types.SET_CROSS_TENANT_SESSION_HOST](state, isHost) {
    state.crossTenantSessionHost = isHost;
  }
};
